import React from "react";
import { Normalize } from "styled-normalize";
import { GlobalStyle } from "./styled";
export const AppWrapper = ({ children }) => (React.createElement(React.Fragment, null,
    React.createElement(Normalize, null),
    React.createElement(GlobalStyle, null),
    children));
